/**
 * 根据权限配置导航
 * 每一个nav项参数：label, path, query
 */
import Permit from '../utils/permit'
import Notice from "@/api/notice.js";
import DownloadFile from "@/api/downloadFile.js";
// import { adapterSetEndpoint } from "@/settings";

let navs = []
//
if (['charge', 'bf'].includes(Permit.edition()) && Permit.extendModels().includes('pdm')) {
  let navProduct = { label: '产品中心', children: [] }
  if (Permit.canActions('productView')) {
    navProduct.children.push({ label: '我的产品', path: '/normal/pdm/products' })
  }
  if (['charge'].includes(Permit.edition()) && Permit.canActions('quoteToCustomerView')) {
    navProduct.children.push({ label: '我的共享', path: '/normal/pdm/quotations' },)
  }
  if (Permit.extendModels().includes('pms') && Permit.canActions('supplierProductView')) {
    navProduct.children.push({ label: '供应商产品', path: '/normal/pdm/supplier-products' },)
  }

  navs.push(navProduct)
}

//
if (Permit.canActions('inquiryQuotationsManage') || Permit.canActions('inquiryInquiriesManage')) {
  let navInquiry = { label: '询价报价', children: [] }
  if (['charge', 'af'].includes(Permit.edition()) && Permit.canActions('inquiryQuotationsManage') && ['manufacturer', 'mt', 'material', 'other'].includes(Permit.currentTenant().type)) {
    navInquiry.children.push({ label: '客户询价', path: '/normal/inquiries/customer' })
  }
  if (['charge', 'bf'].includes(Permit.edition()) && Permit.canActions('inquiryInquiriesManage') && ['trader', 'mt'].includes(Permit.currentTenant().type)) {
    navInquiry.children.push({ label: '我的询价', path: '/normal/inquiries/my' })
  }
  navs.push(navInquiry)
}
//
if (['charge'].includes(Permit.edition()) && Permit.extendModels().includes('rms') && Permit.extendModels().includes('wms') && Permit.canActionsChargeEdition('rentView')) {
  navs.push({ label: '租赁单', path: '/normal/rents' })
}
//
if (['charge'].includes(Permit.edition()) && Permit.extendModels().includes('schedule') && Permit.canActionsChargeEdition('scheduleView')) {
  navs.push({ label: '日程管理', path: '/normal/schedules' })
}
//
if (['charge'].includes(Permit.edition()) && Permit.extendModels().includes('salesTarget') && Permit.canActionsChargeEdition('salesTargetView')) {
  navs.push({ label: '销售目标', path: '/normal/sales-targets' })
}
if (['charge'].includes(Permit.edition()) && (Permit.extendModels().includes('adapterI') || Permit.extendModels().includes('adapterC'))) {
  let navAdapter = { label: '平台对接', children: [] }
  if (Permit.canActions('orderManage')) {
    navAdapter.children.push({ label: '手动导入', path: '/normal/adapter/manual' },)
    navAdapter.children.push({ label: '导入反馈', path: '/normal/adapter/request-responses' },)

  }
  if (Permit.extendModels().includes('adapterC') && Permit.canActionsChargeEdition('adapterCManage')) {
    navAdapter.children.push(
      { label: '淘宝', path: '/normal/adapter/taobaos', divided: true })
  }
  if (Permit.extendModels().includes('adapterI') && Permit.canActionsChargeEdition('adapterIManage')) {
    navAdapter.children.push(
      { label: '亚马逊', path: '/normal/adapter/amazons' },
      { label: 'Shopify', path: '/normal/adapter/shopifys' },
      { label: 'eBay', path: '/normal/adapter/ebays' },
      { label: '速卖通', path: '/normal/adapter/aliexpresses' })
  }
  navs.push(navAdapter)

}

if (Permit.extendModels().includes('report')) {
  navs.push({ label: '财务 • 报表', path: '/fnReport/fn-reports' })
}
if (['charge'].includes(Permit.edition()) && Permit.extendModels().includes('mall') && Permit.canActionsChargeEdition('mallManage')) {
  navs.push({ label: '赢小店', path: '/mall/mall/bargains' })
}
navs.push({ icon: 'download', path: '/normal/downloads', numberFun: DownloadFile.waitingDownloadCount, emitNames: ['emitDownLoad', 'downloadFileDownloadFinish'], dotTipDF: true })
navs.push({ icon: 'bell', path: '/normal/messages/receive', numberFun: Notice.unreadQty, emitNames: ['noticeReadFinish'], dotTipDF: true })
// if (Permit.currentUser() && Permit.currentUser().admin) {
//   navs.push({ label: '设置', path: '/set/perference/users' })
// }
let shortcuts = []
if (['charge'].includes(Permit.edition()) && Permit.canActionsChargeEdition('orderManage')) {
  shortcuts.push({ label: '新增销售订单', path: '/normal/oms/bargains/new' })
}
if (['charge', 'bf'].includes(Permit.edition()) && Permit.canActions('purchaseManage')) {
  shortcuts.push({ label: '新增外采单', path: '/normal/pms/purchases/new' })
}
if (['charge', 'af'].includes(Permit.edition()) && Permit.canActions('deliverAction')) {
  shortcuts.push({ label: '待发货', path: '/normal/lms/pending-delivers' })
}
if (['charge', 'bf'].includes(Permit.edition()) && Permit.canActions('receiveView')) {
  shortcuts.push({ label: '待收货', path: '/normal/lms/pending-receives' })
}
export default {
  items: navs.filter(nav => !nav.children || (nav.children && nav.children.length != 0)),
  shortcuts: shortcuts
};